import Layout from './Layout'
import DataRoomNameCard from './DataRoomNameCard'
import DataRoomLogoCard from './DataRoomLogoCard'
import DataRoomSettingsCard from './DataRoomSettingsCard'
import DataRoomActionsCard from './DataRoomActionsCard'
import GridCard from './GridCard'
import GridContainer from './GridContainer'
import DataRoomBillingCard from './DataRoomBillingCard'
import { useSelectedDataRoom } from 'hooks/useSelectedDataRoom'

export default function DataRoom() {
  const { dataRoom } = useSelectedDataRoom()

  return <Layout>
    {dataRoom && <GridContainer>
      <GridCard xs={12} md={6}>
        <DataRoomNameCard/>
        <DataRoomLogoCard/>
        <DataRoomBillingCard/>
      </GridCard>
      <GridCard xs={12} md={6}>
        <DataRoomSettingsCard/>
      </GridCard>
      <GridCard xs={12}>
        <DataRoomActionsCard/>
      </GridCard>
    </GridContainer>}
  </Layout>
}
